<app-main>
  <h1>Erreur de correspondance</h1>
  <app-generic-table
    [config]="tableConfig"
    [rows]="listErreurCorrespondances"
    [pageInformations]="pageInformations"
    (pageEmit)="pageEvent($event)"
    [detailsbutton]="true"
    (detailsEmit)="openDetails($event)"
    [affranchibutton]="true"
    (affranchiEmit)="createAffranchi($event)"
    [isClickable]="true"
    [emitClickRow]="emitClickRow"
  ></app-generic-table
></app-main>
